// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__oLLve","buttonCancel":"button_buttonCancel__21g3v","buttonOk":"button_buttonOk__2apu_"};